import { render, staticRenderFns } from "./NavCom.vue?vue&type=template&id=fb6f9a16&scoped=true"
import script from "./NavCom.vue?vue&type=script&lang=js"
export * from "./NavCom.vue?vue&type=script&lang=js"
import style0 from "./NavCom.vue?vue&type=style&index=0&id=fb6f9a16&prod&lang=scss&scoped=true"
import style1 from "./NavCom.vue?vue&type=style&index=1&id=fb6f9a16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6f9a16",
  null
  
)

export default component.exports